export const BACKEND_URL = 'https://crmback.agsfacilities.fr/'
export function HIDE_MENU() {
    var links =document.getElementsByClassName('nav-main__links')[0].getElementsByTagName('p');
    document.getElementsByClassName('main-panel')[0].style.width = "calc(100% - 0px)";
    document.getElementsByClassName('sidebar-wrapper')[0].style.width="0px"
    document.getElementsByClassName('sidebar')[0].style.width="0px"
    document.getElementById('burgerburger').style.marginLeft="10px";
    document.getElementById('societe').style.marginLeft="50px";
  }